import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import { AuthFragmentDoc } from './Auth.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginWithCodeMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type LoginWithCodeMutation = { loginWithCode: { authChallenge: Types.AuthChallenge, user: { id: string, firstName: string, lastName: string, email: string, permissions: Array<Types.Permission>, roles: Array<Types.Role>, status: Types.UserStatus } | null, token: { accessToken: string, expiresIn: number, refreshToken: string } | null } };


export const LoginWithCodeDocument = gql`
    mutation LoginWithCode($email: String!, $code: String!) {
  loginWithCode(email: $email, code: $code) {
    ...Auth
  }
}
    ${AuthFragmentDoc}`;
export type LoginWithCodeMutationFn = Apollo.MutationFunction<LoginWithCodeMutation, LoginWithCodeMutationVariables>;

/**
 * __useLoginWithCodeMutation__
 *
 * To run a mutation, you first call `useLoginWithCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithCodeMutation, { data, loading, error }] = useLoginWithCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useLoginWithCodeMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithCodeMutation, LoginWithCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithCodeMutation, LoginWithCodeMutationVariables>(LoginWithCodeDocument, options);
      }
export type LoginWithCodeMutationHookResult = ReturnType<typeof useLoginWithCodeMutation>;
export type LoginWithCodeMutationResult = Apollo.MutationResult<LoginWithCodeMutation>;
export type LoginWithCodeMutationOptions = Apollo.BaseMutationOptions<LoginWithCodeMutation, LoginWithCodeMutationVariables>;